import React from "react";
import "./style.scss";
import AdminBatchList from "../../../components/Admin/AdminBatchList";

const AdminBatchListPage = () => {
  return (
    <div className="admin_batches_page_wrapper">
      <AdminBatchList />
    </div>
  );
};

export default AdminBatchListPage;
